<template>
  <v-layout class="inner-pages" column>
    <Header :header-height="$auth.check() ? '70px': '120px'" />

    <scroll-data>
      <v-flex class="pt-0">
        <h2 class="page-head" id="link-index"><span class="page-heading">Privacy Policy</span></h2>


        <div class="block ">
          <div >

            <div class="block-header" id="term1">
              <h2><span class="title">Overview</span></h2>
            </div>
            <p>Your privacy is important to us, and we have fundamental principles:</p>
            <ul>
              <li>We don't ask you for personal information unless we truly need it. </li>
              <li>We don't share your personal information with anyone except to comply with the law, develop our products, or protect our rights.</li>
              <li>We don't store personal information on our servers unless required for the on-going operation of one of our services.</li>
              <li>In the use of our site and players, we aim to make it simple for you participate as a group member, group lead, author, or sponsor without loss of privacy.  That includes the ability for you to control how much information may be available to others. </li>
            </ul>
            <p>Below is more detail on how we incorporate these goals.</p>


            <div class="block-header" id="term2">
              <h2><span class="title">Website Visitors</span></h2>
            </div>
            <p>Like most website operators, Cogneti, LLC (Cogneti) collects non-personally-identifying information of the sort that web browsers and servers typically make available, such as the browser type, language preference, referring site, and the date and time of each visitor request. Cogneti's purpose in collecting non-personally identifying information is to better understand how Cogneti's visitors use its website. From time to time, Cogneti may release non-personally-identifying information in the aggregate, e.g., by publishing a report on trends in the usage of its website.</p>
            <p>Cogneti also collects potentially personally-identifying information like Internet Protocol (IP) addresses for logged in users and for users leaving comments or messages. Cogneti only discloses logged in user and commenter IP addresses under the same circumstances that it uses and discloses personally-identifying information as described below, except that commenter IP addresses are visible and disclosed to the administrators of the blog where the comment was left.</p>


            <div class="block-header" id="term3">
              <h2><span class="title">Gathering of Personally-Identifying Information</span></h2>
            </div>
            <p>Certain visitors to Cogneti's websites choose to interact with Cogneti in ways that require Cogneti to gather personally-identifying information. The amount and type of information that Cogneti gathers depends on the nature of the interaction. For example, we ask visitors who sign up to provide a username and email address. Those who engage in transactions with Cogneti - by purchasing licenses or services, for example - are asked to provide additional information, including as necessary the personal and financial information required to process those transactions. In each case, Cogneti collects such information only insofar as is necessary or appropriate to fulfill the purpose of the interaction with Cogneti. Cogneti does not disclose personally-identifying information other than as described below. And visitors can always refuse to supply personally-identifying information, with the caveat that it may prevent them from engaging in certain website-related activities.</p>


            <div class="block-header" id="term4">
              <h2><span class="title">Aggregated Statistics</span></h2>
            </div>
            <p>Cogneti may collect statistics about the behavior of visitors to its websites. For instance, Cogneti may monitor the most popular games on the cogneti.com site. Cogneti may display this information publicly or provide it to others. However, Cogneti does not disclose personally-identifying information other than as described below.</p>


            <div class="block-header" id="term5">
              <h2><span class="title">Protection of Certain Personally-Identifying Information</span></h2>
            </div>
            <p>Cogneti discloses potentially personally-identifying and personally-identifying information only to those of its employees, contractors and affiliated organizations that (i) need to know that information in order to process it on Cogneti's behalf or to provide services available at Cogneti's websites, and (ii) that have agreed not to disclose it to others. Some of those employees, contractors and affiliated organizations may be located outside of your home country; by using Cogneti's websites, you consent to the transfer of such information to them. Cogneti will not rent or sell potentially personally-identifying and personally-identifying information to anyone. Other than to its employees, contractors and affiliated organizations, as described above, Cogneti discloses potentially personally-identifying and personally-identifying information only in response to a subpoena, court order or other governmental request, or when Cogneti believes in good faith that disclosure is reasonably necessary to protect the property or rights of Cogneti, third parties or the public at large. If you are a registered user of a Cogneti website and have supplied your email address, Cogneti may occasionally send you an email to tell you about new features, solicit your feedback, or just keep you up to date with what's going on with Cogneti and our products. We primarily use our various players to communicate this type of information, so we expect to keep this type of email to a minimum. If you send us a request (for example via a support email or via one of our feedback mechanisms), we reserve the right to publish it in order to help us clarify or respond to your request or to help us support other users. Cogneti takes all measures reasonably necessary to protect against the unauthorized access, use, alteration or destruction of potentially personally-identifying and personally-identifying information.</p>


            <div class="block-header" id="term6">
              <h2><span class="title">Cookies</span></h2>
            </div>
            <p>A cookie is a string of information that a website stores on a visitor's computer, and that the visitor's browser provides to the website each time the visitor returns. Cogneti uses cookies to help Cogneti identify and track visitors, their usage of Cogneti website, and their website access preferences. Cogneti visitors who do not wish to have cookies placed on their computers should set their browsers to refuse cookies before using Cogneti's websites, with the drawback that certain features of Cogneti's websites may not function properly without the aid of cookies.</p>

            <div class="block-header" id="term7">
              <h2><span class="title">Business Transfers</span></h2>
            </div>
            <p>If Cogneti, or substantially all of its assets, were acquired, or in the unlikely event that Cogneti goes out of business or enters bankruptcy, user information would be one of the assets that is transferred or acquired by a third party. You acknowledge that such transfers may occur, and that any acquirer of Cogneti may continue to use your personal information as set forth in this policy.</p>


            <div class="block-header" id="term8">
              <h2><span class="title">Advertisements (Ads)</span></h2>
            </div>
            <p>Ads appearing on any of our websites or players may be delivered to users by advertising partners, who may set cookies. These cookies allow the ad server to recognize your computer each time they send you an online advertisement to compile information about you or others who use your computer. This information allows ad networks to, among other things, deliver targeted advertisements that they believe will be of most interest to you. This Privacy Policy covers the use of cookies by Cogneti and does not cover the use of cookies by any advertisers.</p>


            <div class="block-header" id="term9">
              <h2><span class="title">Privacy Policy Changes</span></h2>
            </div>
            <p>Although most changes are likely to be minor, Cogneti may change its Privacy Policy from time to time, and in Cogneti's sole discretion. Cogneti encourages visitors to frequently check this page for any changes to its Privacy Policy. Your continued use of this site after any change in this Privacy Policy will constitute your acceptance of such change.</p>


            <div class="block-header" id="term10">
              <h2><span class="title">Change log</span></h2>
            </div>
            <p>October 28, 2017: Created the privacy policy using original material available under Creative Commons ShareAlike 2.5 license (CC BY-SA 2.5) </p>
          </div>

          <v-btn
            v-if="scrolled > 200"
            fixed
            dark
            small
            fab
            bottom
            right
            color="blue"
            @click.prevent="$vuetify.goTo('#link-index')"
          >
            <v-icon>arrow_upward</v-icon>
          </v-btn>

        </div>
      </v-flex>
    </scroll-data>

  </v-layout>



</template>

<script>
  import ScrollData from '../../ScrollData'
  import Header from '../../layouts/Header'
  export default {
    name: 'PrivacyPolicy',
    components: {Header, ScrollData},
    props: {
      msg: String
    },
    data () {
      return {
        scrolled: 0
      }
    },
    created () {
      window.addEventListener('scroll', this.handleScroll)
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
      handleScroll () {
        this.scrolled = window.scrollY
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/views/guest/PrivacyPolicy.vue